<main class="container my-5 pt-5">
    <div class="container-fluid main-content mt-5">
        <div class="custom-card">
            <div class="card-body d-flex row justify-content-center text-center">
                <h2 class="custom-card-title">Contact Us</h2>

                <a target="_blank" href="https://www.gwinnettcb.org">Gwinnett Clean & Beautiful</a>

                <div class="row g-4 justify-content-center">
                    <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
                        <app-feature-card class="w-100" header="EMAIL" symbol="mail" description="gwinnettcb@gwinnettcb.org" />
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
                        <app-feature-card class="w-100" header="PHONE" symbol="phone" description="(770) 822-5187" />
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 d-flex">
                        <app-feature-card class="w-100" header="ADDRESS" symbol="explore" description="446 W Crogan St Ste 430, Lawrenceville, GA 30046" />
                    </div>
                  <div class="w-100 text-end mt-3">
                    v3.0 (03/06/2026)
                  </div>
                </div>
            </div>
        </div>
    </div>
</main>
